<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column prop="Name" label="名称" width>
        </el-table-column>
        <el-table-column prop="UsingTypeStr" label="应用类型" width>
        </el-table-column>
        <el-table-column prop="LeaveTypeName" label="请假类型" width>
        </el-table-column>

        <el-table-column prop="CampusName" label="校区" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.CampusName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="适用范围" min-width="180">
          <template slot-scope="scope">
            <template v-if="scope.row.UsingType === 'stu_leave' || scope.row.UsingType === 'agent_leave'">
              <el-button
                v-if="scope.row.ScopeType === 'student'"
                type="text"
                size="small"
                icon="el-icon-user"
                class="scope-link-btn"
                @click.stop="openScopeViewDialog(scope.row, 'student')">
                已选 {{ (scope.row.StudentNames || []).length }} 名学生
              </el-button>
              <el-button
                v-else-if="parseNames(scope.row.GradeName).length"
                type="text"
                size="small"
                icon="el-icon-office-building"
                class="scope-link-btn"
                @click.stop="openScopeViewDialog(scope.row, 'grade')">
                已选 {{ parseNames(scope.row.GradeName).length }} 个年级
              </el-button>
              <el-tag
                v-else-if="scope.row.LiveTypeNames"
                size="small"
                type="success"
                effect="plain"
                class="scope-tag">
                <i class="el-icon-circle-check"></i> 全校【{{ scope.row.LiveTypeNames }}】通用
              </el-tag>
              <el-tag v-else size="small" type="info" effect="plain" class="scope-tag">
                全校通用
              </el-tag>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="学生类型" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.LiveTypeNames || '-' }}
          </template>
        </el-table-column>

        <el-table-column prop="Sort" label="序号" width>
        </el-table-column>
        <el-table-column prop="CreateTime" label="添加时间" width="180">
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="160" align="center">
          <template slot-scope="scope">
            <div class="table-op-stacked">
              <el-button @click="showAddApprovalNode(scope.row)" type="text" style="margin: 0 !important;">
                审批人员设置
              </el-button>
              <el-button @click="showCopyToUsers(scope.row)" type="text" style="margin: 0 !important;">
                抄送人员设置
              </el-button>
            </div>
          </template>
        </el-table-column>

      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog title="编辑审批流程" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">

          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>



          <el-form-item label="应用类型" prop="UsingType">
            <el-select v-model="editForm.UsingType" placeholder="请选择应用类型">
              <el-option v-for="item in usingTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="请假类型" prop="LeaveTypeId" v-if="!isAdjustCourseType(editForm.UsingType)">
            <el-select v-model="leaveTypeId" placeholder="请选择请假类型">
              <el-option v-for="item in leaveTypeList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="适用范围">
            <el-radio-group v-model="editForm.ScopeType">
              <el-radio label="all">通用</el-radio>
              <el-radio label="condition">条件范围</el-radio>
              <el-radio label="student">指定学生</el-radio>
            </el-radio-group>
            <div style="margin-top: 6px; color: #909399; font-size: 12px; line-height: 1.6;">
              家长请假和教师代请假都按这个顺序匹配：指定学生 &gt; 学生类型+年级 &gt; 学生类型 &gt; 年级 &gt; 通用。同一级有多条时，按序号从小到大取第一条。
            </div>
          </el-form-item>

          <el-form-item label="学生类型" v-if="editForm.ScopeType === 'condition'">
            <el-select v-model="editForm.LiveTypeIds" multiple placeholder="可选，不选表示不限类型" style="width: 100%;">
              <el-option v-for="item in liveTypeOptions" :key="item.LiveTypeId" :label="item.LiveTypeName" :value="item.LiveTypeId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="校区" v-if="editForm.ScopeType === 'condition'">
            <el-select v-model="editCampusId" placeholder="请选择校区" style="width: 100%;" @change="onEditCampusChange">
              <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
            <div style="margin-top: 6px; color: #909399; font-size: 12px;">
              校区仅用于筛选年级；切换校区不会自动修改已选年级
            </div>
          </el-form-item>

          <el-form-item label="年级" v-if="editForm.ScopeType === 'condition'">
            <el-select v-model="editForm.GradeIds" multiple placeholder="可选，不选表示不限年级" style="width: 100%;" @change="onEditGradeChange">
              <el-option v-for="item in editGradeOptions" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
            <div style="margin-top: 6px; color: #909399; font-size: 12px;">
              学生类型与年级都填写时，学生需同时满足；同一校区可多选年级
            </div>
          </el-form-item>

          <el-form-item label="指定学生" v-if="editForm.ScopeType === 'student'">
            <div class="picked-panel">
              <div class="picked-panel-head">
                <span v-if="(editForm.StudentNames || []).length" class="picked-count">
                  <i class="el-icon-user"></i> 已选 {{ editForm.StudentNames.length }} 名学生
                </span>
                <span v-else class="picked-empty">暂未选择学生，请从通讯录选择</span>
                <span class="picked-actions">
                  <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="openStudentPicker('edit')">选择学生</el-button>
                  <el-button v-if="(editForm.StudentNames || []).length" size="mini" @click="clearStudents('edit')">清空</el-button>
                </span>
              </div>
              <div v-if="(editForm.StudentNames || []).length" class="picked-tags">
                <el-tag v-for="(name, index) in editForm.StudentNames.slice(0, studentPreviewSize)" :key="index"
                  size="small" type="info" effect="plain">{{ name }}</el-tag>
                <el-tag v-if="editForm.StudentNames.length > studentPreviewSize" size="small" class="picked-more"
                  @click.native="openScopeViewDialog(editForm, 'student')">
                  +{{ editForm.StudentNames.length - studentPreviewSize }} 查看全部
                </el-tag>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="序号" prop="Sort">
            <div style="display: flex; align-items: center;">
              <el-input-number v-model="editForm.Sort" :min="1" style="width: 120px;"></el-input-number>
              <span style="margin-left: 8px; color: #909399; font-size: 12px;">
                同一匹配级别有多条流程时，按序号从小到大取第一条
              </span>
            </div>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增审批流程" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="名称" prop="Name">
            <el-input v-model="addForm.Name" auto-complete="off"></el-input>
          </el-form-item>



          <el-form-item label="应用类型" prop="UsingType">
            <el-select v-model="addForm.UsingType" placeholder="请选择应用类型">
              <el-option v-for="item in usingTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="请假类型" prop="LeaveTypeId" v-if="!isAdjustCourseType(addForm.UsingType)">
            <el-select v-model="leaveTypeId" placeholder="请选择请假类型">
              <el-option v-for="item in leaveTypeList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="适用范围">
            <el-radio-group v-model="addForm.ScopeType">
              <el-radio label="all">通用</el-radio>
              <el-radio label="condition">条件范围</el-radio>
              <el-radio label="student">指定学生</el-radio>
            </el-radio-group>
            <div style="margin-top: 6px; color: #909399; font-size: 12px; line-height: 1.6;">
              家长请假和教师代请假都按这个顺序匹配：指定学生 &gt; 学生类型+年级 &gt; 学生类型 &gt; 年级 &gt; 通用。同一级有多条时，按序号从小到大取第一条。
            </div>
          </el-form-item>

          <el-form-item label="学生类型" v-if="addForm.ScopeType === 'condition'">
            <el-select v-model="addForm.LiveTypeIds" multiple placeholder="可选，不选表示不限类型" style="width: 100%;">
              <el-option v-for="item in liveTypeOptions" :key="item.LiveTypeId" :label="item.LiveTypeName" :value="item.LiveTypeId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="校区" v-if="addForm.ScopeType === 'condition'">
            <el-select v-model="addCampusId" placeholder="请选择校区" style="width: 100%;" @change="onAddCampusChange">
              <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
            <div style="margin-top: 6px; color: #909399; font-size: 12px;">
              校区仅用于筛选年级；切换校区不会自动修改已选年级
            </div>
          </el-form-item>

          <el-form-item label="年级" v-if="addForm.ScopeType === 'condition'">
            <el-select v-model="addForm.GradeIds" multiple placeholder="可选，不选表示不限年级" style="width: 100%;" @change="onAddGradeChange">
              <el-option v-for="item in addGradeOptions" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
            <div style="margin-top: 6px; color: #909399; font-size: 12px;">
              学生类型与年级都填写时，学生需同时满足；同一校区可多选年级
            </div>
          </el-form-item>

          <el-form-item label="指定学生" v-if="addForm.ScopeType === 'student'">
            <div class="picked-panel">
              <div class="picked-panel-head">
                <span v-if="(addForm.StudentNames || []).length" class="picked-count">
                  <i class="el-icon-user"></i> 已选 {{ addForm.StudentNames.length }} 名学生
                </span>
                <span v-else class="picked-empty">暂未选择学生，请从通讯录选择</span>
                <span class="picked-actions">
                  <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="openStudentPicker('add')">选择学生</el-button>
                  <el-button v-if="(addForm.StudentNames || []).length" size="mini" @click="clearStudents('add')">清空</el-button>
                </span>
              </div>
              <div v-if="(addForm.StudentNames || []).length" class="picked-tags">
                <el-tag v-for="(name, index) in addForm.StudentNames.slice(0, studentPreviewSize)" :key="index"
                  size="small" type="info" effect="plain">{{ name }}</el-tag>
                <el-tag v-if="addForm.StudentNames.length > studentPreviewSize" size="small" class="picked-more"
                  @click.native="openScopeViewDialog(addForm, 'student')">
                  +{{ addForm.StudentNames.length - studentPreviewSize }} 查看全部
                </el-tag>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="序号" prop="Sort">
            <div style="display: flex; align-items: center;">
              <el-input-number v-model="addForm.Sort" :min="1" style="width: 120px;"></el-input-number>
              <span style="margin-left: 8px; color: #909399; font-size: 12px;">
                同一匹配级别有多条流程时，按序号从小到大取第一条
              </span>
            </div>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog title="添加审批节点" :width="isCourseAdjustment ? '640px' : '860px'" :visible.sync="addApprovalNodeVisible" :close-on-click-modal="false" center
        destroy-on-close>
        <!-- 节点按固定列网格排布，保证各行对齐。最后修改：2026-10-03 -->
        <el-table :data="approvalNodes" class="node-table" style="width: 100%;" empty-text="暂无审批节点，点击下方「添加节点」">
          <el-table-column prop="index" label="序号" width="64" align="center">
            <template slot-scope="scope">
              <span class="node-index">{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <div class="node-grid node-grid-head" :class="{ 'no-duration': isCourseAdjustment }">
                <span>审批角色</span>
                <span>审批人</span>
                <span v-if="!isCourseAdjustment">
                  审批时长
                  <el-tooltip content="请假时长达到该天数才流转到本节点；输入小时会自动换算为天" placement="top">
                    <i class="el-icon-question node-head-help"></i>
                  </el-tooltip>
                </span>
                <span class="node-head-op">操作</span>
              </div>
            </template>
            <template slot-scope="scope">
              <el-form :model="scope.row" :rules="approvalFormRules" :ref="`approvalForm${scope.$index}`"
                class="node-grid" :class="{ 'no-duration': isCourseAdjustment }">
                <el-form-item prop="role">
                  <el-select v-model="scope.row.role" :multiple="isFirstAgentLeaveNode(scope.$index)"
                    placeholder="请选择角色" @change="roleChange(scope.$index)">
                    <el-option v-for="item in getRoleOptions(scope.$index)" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="specificUsers">
                  <template v-if="scope.row.role === 'specificPerson'">
                    <!-- 调代课审批人仅限课表管理员，候选范围受限，保留下拉 -->
                    <el-select v-if="isCourseAdjustment" v-model="scope.row.specificUsers" multiple filterable
                      collapse-tags placeholder="请选择课表管理员" @change="specificUsersChange(scope.$index)">
                      <el-option v-for="user in userList" :key="user.Id" :label="user.TeacherName"
                        :value="user.Id"></el-option>
                    </el-select>
                    <el-tooltip v-else placement="top" :disabled="!scope.row.specificUsers.length"
                      :content="getNodeUserNames(scope.row)">
                      <div class="node-picked" :class="{ 'is-empty': !scope.row.specificUsers.length }"
                        @click="openNodePicker(scope.$index)">
                        <i class="el-icon-user"></i>
                        <span class="node-picked-text">
                          {{ scope.row.specificUsers.length ? `已选 ${scope.row.specificUsers.length} 人` : '选择人员' }}
                        </span>
                        <i class="el-icon-arrow-right node-picked-arrow"></i>
                      </div>
                    </el-tooltip>
                  </template>
                  <div v-else class="node-auto">按角色自动匹配</div>
                </el-form-item>

                <el-form-item v-if="!isCourseAdjustment" prop="days">
                  <div class="node-duration">
                    <el-input-number v-model="scope.row.days" :min="0" :step="0.01" :precision="2"
                      controls-position="right" @change="handleDaysInput(scope.$index)" />
                    <span class="node-unit">天</span>
                    <el-input-number v-model="scope.row.hours" :min="0" :step="0.01" :precision="2"
                      controls-position="right" placeholder="小时" @change="handleHoursInput(scope.$index)" />
                    <span class="node-unit">小时</span>
                  </div>
                </el-form-item>

                <el-form-item class="node-op">
                  <el-button type="text" icon="el-icon-delete" class="node-del-btn"
                    @click="removeNode(scope.$index)">删除</el-button>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="isCourseAdjustment" class="node-foot-tip">审批人需要先录入课表管理员</div>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addNode" style="margin-right: 10px;">添加节点</el-button>
          <el-button type="primary" @click="submitForm" style="margin-right: 10px;">保存</el-button>
          <el-button @click.native="addApprovalNodeVisible = false">取消</el-button>
        </div>
      </el-dialog>

      <!--抄送人员设置弹窗-->
      <el-dialog :title="copyToTitle" width="50%" :visible.sync="copyToUsersVisible" :close-on-click-modal="false"
        center destroy-on-close>
        <!-- label-width 与同页其它表单一致，避免未设宽度时浮动 label 与多选 tag 重叠。最后修改：2026-09-20 -->
        <el-form :model="copyToForm" ref="copyToForm" label-width="100px">
          <el-form-item label="抄送人员" prop="copyToUsers" style="margin-bottom: 20px;">
            <!-- 调代课抄送仅限课表管理员，候选范围受限，保留下拉 -->
            <el-select v-if="isAdjustCourseType(currentUsingType)" v-model="copyToForm.copyToUsers" multiple filterable
              placeholder="请选择或输入人员" style="width: 100%;">
              <el-option v-for="user in userList" :key="user.Id" :label="user.TeacherName" :value="user.Id"></el-option>
            </el-select>
            <div v-else class="picked-panel">
              <div class="picked-panel-head">
                <span v-if="copyToForm.copyToUsers.length" class="picked-count">
                  <i class="el-icon-user"></i> 已选 {{ copyToForm.copyToUsers.length }} 人
                </span>
                <span v-else class="picked-empty">暂未选择抄送人员，请从通讯录选择</span>
                <span class="picked-actions">
                  <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="ccPickerVisible = true">选择人员</el-button>
                  <el-button v-if="copyToForm.copyToUsers.length" size="mini" @click="clearCcUsers">清空</el-button>
                </span>
              </div>
              <div v-if="copyToForm.copyToUsers.length" class="picked-tags picked-tags-scroll">
                <el-tag v-for="(id, index) in copyToForm.copyToUsers" :key="id" size="small" type="info" effect="plain"
                  closable @close="removeCcUser(index)">{{ copyToForm.copyToNames[index] || id }}</el-tag>
              </div>
            </div>
            <div style="margin-top: 10px; color: #606266; font-size: 12px;">
              {{ copyToTip }}
            </div>
          </el-form-item>
          <template v-if="isLeaveCcType">
            <el-form-item label="抄送班主任">
              <el-switch v-model="copyToForm.ccClassTeacher"></el-switch>
              <span class="cc-switch-tip">开启后，审批通过时同时通知该学生所在班级的班主任</span>
            </el-form-item>
            <el-form-item label="通知家长">
              <el-switch v-model="copyToForm.notifyParent"></el-switch>
              <span class="cc-switch-tip">关闭后，审批通过时不再向家长推送通知</span>
            </el-form-item>
          </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="copyToUsersVisible = false">取消</el-button>
          <el-button type="primary" @click.native="saveCopyToUsers" :loading="copyToLoading">保存</el-button>
        </div>
      </el-dialog>

      <!-- 列表适用范围查看弹窗。创建于 2026-10-03 -->
      <el-dialog :title="scopeViewDialog.title" :visible.sync="scopeViewDialog.visible" width="560px"
        :close-on-click-modal="false" append-to-body custom-class="scope-view-dialog">
        <div class="scope-view-head">
          <div class="scope-view-head-item">
            <span class="label">流程：</span>
            <span class="val">{{ scopeViewDialog.processName || '-' }}</span>
          </div>
          <div class="scope-view-head-item" v-if="scopeViewDialog.kind === 'grade'">
            <span class="label">校区：</span>
            <span class="val">{{ scopeViewDialog.campusName || '-' }}</span>
          </div>
          <div class="scope-view-head-item" v-if="scopeViewDialog.kind === 'grade'">
            <span class="label">学生类型：</span>
            <span class="val">{{ scopeViewDialog.liveTypeNames || '不限' }}</span>
          </div>
          <div class="scope-view-head-item">
            <span class="label">总数：</span>
            <span class="val count-badge">{{ scopeViewDialog.items.length }} {{ scopeViewDialog.unit }}</span>
          </div>
        </div>

        <div class="scope-view-toolbar">
          <el-input v-model="scopeViewDialog.filterKey" size="small" :placeholder="scopeViewDialog.searchPlaceholder"
            prefix-icon="el-icon-search" clearable class="scope-view-search-input" />
        </div>

        <el-table :data="filteredScopeViewItems" size="small" max-height="340" border stripe>
          <el-table-column type="index" label="序号" width="70" align="center" />
          <el-table-column prop="name" :label="scopeViewDialog.columnLabel" min-width="180" />
          <el-table-column v-if="scopeViewDialog.kind === 'student'" label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="delete-action" :loading="scope.row.removing"
                @click="removeScopeStudent(scope.row)">删除</el-button>
            </template>
          </el-table-column>
          <div slot="empty" class="scope-view-empty">暂无匹配数据</div>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button @click="scopeViewDialog.visible = false">关闭</el-button>
        </div>
      </el-dialog>

      <person-scope-picker-dialog
        :visible.sync="ccPickerVisible"
        directory-scope="internal"
        :show-scope-tabs="false"
        :multiple="true"
        :scope-department-id="ccScopeDepartmentId"
        :selected-people="ccSelectedPeople"
        @confirm="onCcPicked"
      />

      <person-scope-picker-dialog
        :visible.sync="nodePickerVisible"
        directory-scope="internal"
        :show-scope-tabs="false"
        :multiple="true"
        :scope-department-id="nodeScopeDepartmentId"
        :selected-people="nodeSelectedPeople"
        @confirm="onNodePicked"
      />

      <person-scope-picker-dialog
        :visible.sync="studentPickerVisible"
        directory-scope="teaching"
        :show-scope-tabs="false"
        :multiple="true"
        :scope-department-id="DepartmentId"
        :selected-people="pickerSelectedPeople"
        @confirm="onStudentsPicked"
      />

    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getLeaveApprovalProcessListPage, removeLeaveApprovalProcess, editLeaveApprovalProcess, addLeaveApprovalProcess, removeLeaveApprovalProcessStudent, getLeaveTypeList, getProcessOfficer, addProcessOfficer, getProcessCc, saveProcessCc, getScheduleAdminsForApproval, getCampusList } from '../../api/modules/misc';
import { getTeachingDepartmentTree, getSubGrades } from '../../api/modules/department';
import { fetchStudentLiveTypesByDeptId } from '../../utils/studentLiveType';
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog';
import { BaseApiUrl } from '../../api/base';
import { getTeacherMasterList } from '../../api/modules/personnel';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

// 定义转换函数，将对象属性名首字母转换为小写
function convertKeysToLower(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(item => convertKeysToLower(item));
  }
  const newObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = key.charAt(0).toLowerCase() + key.slice(1);
      newObj[newKey] = convertKeysToLower(obj[key]);
    }
  }
  return newObj;
}

export default {
  components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      usingTypeOptions: [
        {
          value: 'stu_leave',
          label: '学生请假'
        },
        {
          value: 'agent_leave',
          label: '教师代请假'
        }
      ],
      roleOptions: [
        { label: '班主任', value: 'classTeacher' },
        { label: '家长', value: 'parent' },
        { label: '年级组长', value: 'prefect' },
        { label: '部门主管', value: 'manager' },
        { label: '校长', value: 'headmaster' },
        { label: '指定人员', value: 'specificPerson' }
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        UsingType: [
          { required: true, message: '请选应用类型', trigger: 'change' }
        ],
        GradeId: [
          {
            validator: (rule, value, callback) => {
              // 调代课时，GradeId 实际存的是校区ID，必须选择
              if (this.editForm && this.isAdjustCourseType(this.editForm.UsingType)) {
                if (!value) {
                  return callback(new Error('请选择校区'));
                }
              }
              callback();
            },
            trigger: 'change'
          }
        ]
      },
      gradeList: [], // 新增年级列表（非调代课使用）
      campusOptions: [], // 校区列表
      liveTypeOptions: [],
      editCampusId: '',
      addCampusId: '',
      editGradeOptions: [],
      addGradeOptions: [],
      editGradeDrafts: {},
      addGradeDrafts: {},
      studentPickerVisible: false,
      studentPickerTarget: 'add',
      studentPreviewSize: 6,
      // 列表适用范围查看弹窗状态。创建于 2026-10-03
      scopeViewDialog: {
        visible: false,
        kind: 'grade',
        title: '',
        processName: '',
        campusName: '',
        liveTypeNames: '',
        unit: '个年级',
        columnLabel: '年级',
        searchPlaceholder: '搜索年级名称...',
        items: [],
        filterKey: '',
        processId: 0,
        sourceRow: null
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Name: "",
        UsingType: "",
        LeaveTypeId: 0,
        GradeId: '',
        ScopeType: 'all',
        GradeIds: [],
        LiveTypeIds: [],
        StudentIds: [],
        StudentNames: [],
        Sort: 0,
        DepartmentId: 0
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        UsingType: [
          { required: true, message: '请选应用类型', trigger: 'change' }
        ],
        GradeId: [
          {
            validator: (rule, value, callback) => {
              // 调代课时，GradeId 实际存的是校区ID，必须选择
              if (this.addForm && this.isAdjustCourseType(this.addForm.UsingType)) {
                if (!value) {
                  return callback(new Error('请选择校区'));
                }
              }
              callback();
            },
            trigger: 'change'
          }
        ]
      },
      //新增界面数据
      addForm: {
        Name: "",
        UsingType: "",
        LeaveTypeId: 0,
        GradeId: '',
        ScopeType: 'all',
        GradeIds: [],
        LiveTypeIds: [],
        StudentIds: [],
        StudentNames: [],
        Sort: 0,
        DepartmentId: 0
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      leaveTypeList: [],
      leaveTypeId: "",

      //审批节点
      processId: "",
      addApprovalNodeVisible: false,
      // 存储所有审批节点
      approvalNodes: [],
      // 表单验证规则
      approvalFormRules: {
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        specificUsers: [
          { type: 'array', required: false, message: '请选择指定人员', trigger: 'change' }
        ],
        days: [
          {
            type: 'number',
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value === undefined || value === null || value === '') {
                // 当值为空时，提示请输入天数
                callback(new Error('请输入天数'));
              } else {
                if (typeof value === 'string') {
                  value = Number(value);
                }
                if (isNaN(value)) {
                  callback(new Error('请输入有效的数字'));
                } else if (value < 0) {
                  callback(new Error('天数必须大于0'));
                } else {
                  callback();
                }
              }
            }
          }
        ]
      },
      // 模拟用户列表
      userList: [
      ],

      // 抄送人员相关数据
      copyToUsersVisible: false,
      copyToLoading: false,
      copyToForm: {
        enabled: false,
        copyToUsers: [],
        copyToNames: [],
        ccClassTeacher: false,
        notifyParent: true
      },
      ccPickerVisible: false,
      ccScopeDepartmentId: 0,
      // 审批节点“指定人员”通讯录选人。创建于 2026-10-03
      nodePickerVisible: false,
      nodePickerIndex: -1,
      nodeScopeDepartmentId: 0,
      nodeUserNameMap: {},
      currentProcessId: "",
      currentUsingType: ""
    };
  },

  computed: {
    currentProcess() {
      return this.users.find(u => u.Id === this.processId);
    },
    isAgentLeave() {
      // 当前审批流程类型是否为“教师代请假”
      return this.currentProcess && this.currentProcess.UsingType === 'agent_leave';
    },
    isStuLeave() {
      // 当前审批流程类型是否为“学生请假”
      return this.currentProcess && this.currentProcess.UsingType === 'stu_leave';
    },
    isCourseAdjustment() {
      // 当前审批流程类型是否为“调代课 / 特殊课程调代课”（同节点配置，仅 UsingType 不同）
      const process = this.users.find(u => u.Id === this.processId);
      return process && this.isAdjustCourseType(process.UsingType);
    },
    copyToTitle() {
      if (this.isAdjustCourseType(this.currentUsingType)) {
        return "调代课通过抄送人员设置";
      }
      return "请假通过抄送人员设置";
    },
    copyToTip() {
      if (this.isAdjustCourseType(this.currentUsingType)) {
        return "调代课申请通过后，系统将自动通知以上选择的抄送人员";
      }
      return "请假申请通过后，系统将自动通知以上选择的抄送人员";
    },
    // 是否为学生请假 / 教师代请假流程（显示班主任、家长开关）。创建于 2026-10-03
    isLeaveCcType() {
      return this.currentUsingType === 'stu_leave' || this.currentUsingType === 'agent_leave';
    },
    // 适用范围弹窗中按关键字过滤后的列表。创建于 2026-10-03
    filteredScopeViewItems() {
      const list = this.scopeViewDialog.items || [];
      const key = (this.scopeViewDialog.filterKey || '').trim().toLowerCase();
      return list.filter(item => {
        const name = item && typeof item === 'object' ? item.name : item;
        return !key || String(name).toLowerCase().includes(key);
      }).map(item => (item && typeof item === 'object' ? item : { name: item }));
    },
    // 抄送人员通讯录回显。创建于 2026-10-03
    ccSelectedPeople() {
      const names = this.copyToForm.copyToNames || [];
      return (this.copyToForm.copyToUsers || []).map((id, index) => ({ id: id, name: names[index] || '' }));
    },
    // 当前审批节点已选指定人员回显。创建于 2026-10-03
    nodeSelectedPeople() {
      const node = this.approvalNodes[this.nodePickerIndex];
      if (!node) return [];
      return (node.specificUsers || []).map(id => ({ id: id, name: this.getNodeUserName(id) }));
    },
    pickerSelectedPeople() {
      const form = this.studentPickerTarget === 'edit' ? this.editForm : this.addForm;
      const ids = form.StudentIds || [];
      const names = form.StudentNames || [];
      return ids.map((id, index) => ({ id: id, name: names[index] || '' }));
    }
  },

  methods: {

    // 将“、”分隔的名称拆成数组。创建于 2026-10-03
    parseNames(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      return String(val).split('、').map(s => s.trim()).filter(s => s.length > 0);
    },
    // 打开适用范围查看弹窗（年级 / 指定学生）。创建于 2026-10-03
    openScopeViewDialog(row, kind) {
      if (!row) return;
      const isStudent = kind === 'student';
      const studentItems = (row.StudentIds || []).map((id, index) => ({
        id: id,
        name: (row.StudentNames && row.StudentNames[index]) || String(id),
        removing: false
      }));
      this.scopeViewDialog = {
        visible: true,
        kind: kind,
        title: `${isStudent ? '查看指定学生' : '查看适用年级'} - ${row.Name || '审批流程'}`,
        processName: row.Name || '',
        campusName: row.CampusName || '',
        liveTypeNames: row.LiveTypeNames || '',
        unit: isStudent ? '名学生' : '个年级',
        columnLabel: isStudent ? '学生姓名' : '年级',
        searchPlaceholder: isStudent ? '搜索学生姓名...' : '搜索年级名称...',
        items: isStudent ? studentItems : this.parseNames(row.GradeName),
        filterKey: '',
        processId: row.Id || 0,
        sourceRow: row
      };
    },
    // 从指定学生名单移除一人。档案已删除、只剩编号时也可移除。创建于 2026-10-15
    removeScopeStudent(item) {
      if (!item || !item.id || item.removing) return;
      const persisted = !!this.scopeViewDialog.processId;
      const isLast = persisted && (this.scopeViewDialog.items || []).length <= 1;
      const name = item.name || item.id;
      const tip = isLast
        ? `「${name}」是最后一名指定学生，移除后该流程将按通用范围匹配，确定删除吗？`
        : `确定从该流程中移除「${name}」吗？`;
      this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
        const processId = this.scopeViewDialog.processId;
        if (!processId) {
          this.applyScopeStudentRemoved(item.id, isLast);
          this.$message({ message: '已移除', type: 'success' });
          return;
        }
        item.removing = true;
        removeLeaveApprovalProcessStudent({ processId: processId, studentId: item.id }).then((res) => {
          item.removing = false;
          if (util.isEmt.format(res)) return;
          if (!res.data.success) {
            this.$message({ message: res.data.msg || '移除失败', type: 'error' });
            return;
          }
          this.applyScopeStudentRemoved(item.id, isLast);
          this.$message({
            message: isLast ? '已移除，该流程已无指定学生，适用范围变为通用' : '已移除',
            type: 'success'
          });
          if (isLast) this.scopeViewDialog.visible = false;
        }).catch(() => {
          item.removing = false;
        });
      }).catch(() => { });
    },
    // 同步弹窗、列表和编辑表单里的指定学生。创建于 2026-10-15
    applyScopeStudentRemoved(studentId, isLast) {
      const dialog = this.scopeViewDialog;
      const index = (dialog.items || []).findIndex(row => String(row.id) === String(studentId));
      if (index >= 0) dialog.items.splice(index, 1);

      const rows = [];
      if (dialog.sourceRow) rows.push(dialog.sourceRow);
      if (dialog.processId) {
        const listRow = (this.users || []).find(row => String(row.Id) === String(dialog.processId));
        if (listRow && rows.indexOf(listRow) < 0) rows.push(listRow);
        if (this.editForm && String(this.editForm.Id) === String(dialog.processId) && rows.indexOf(this.editForm) < 0) {
          rows.push(this.editForm);
        }
      }
      rows.forEach(row => {
        if (!row.StudentIds) return;
        const studentIndex = row.StudentIds.findIndex(id => String(id) === String(studentId));
        if (studentIndex >= 0) {
          row.StudentIds.splice(studentIndex, 1);
          if (row.StudentNames) row.StudentNames.splice(studentIndex, 1);
        }
        if (isLast && row.StudentIds.length === 0) row.ScopeType = 'all';
      });
    },

    isAdjustCourseType(ut) {
      return ut === 'course_adjustment' || ut === 'special_course_adjustment';
    },

    // 判断是否为第一个节点且为教师代请假
    isFirstAgentLeaveNode(index) {
      return this.isAgentLeave && index === 0;
    },

    // 获取角色选项
    getRoleOptions(index) {
      if (this.isCourseAdjustment) {
        // 调代课只能选指定人员
        return this.roleOptions.filter(item => item.value === 'specificPerson');
      }

      // 获取所有已选角色（排除当前节点），但不包含 specificPerson
      const selectedRoles = this.approvalNodes
        .filter((node, i) => i !== index)
        .map(node => node.role)
        .flat()
        .filter(role => role !== 'specificPerson'); // 只过滤非指定人员

      // 角色过滤函数
      const filterRoles = (options) => {
        return options.filter(item =>
          item.value === 'specificPerson' || !selectedRoles.includes(item.value)
        );
      };

      if (this.isAgentLeave) {
        if (index === 0) {
          // 教师代请假第一个节点只能选班主任和家长
          return filterRoles([
            { label: '班主任', value: 'classTeacher' },
            { label: '家长', value: 'parent' }
          ]);
        } else {
          // 其他节点不能选班主任和家长
          return filterRoles(
            this.roleOptions.filter(
              item => item.value !== 'classTeacher' && item.value !== 'parent'
            )
          );
        }
      } else if (this.isStuLeave) {
        // 学生请假不能选家长
        return filterRoles(
          this.roleOptions.filter(item => item.value !== 'parent')
        );
      }
      // 其他流程类型不限制，但也不能重复（指定人员可重复）
      return filterRoles(this.roleOptions);
    },

    loadLiveTypes(departmentId) {
      fetchStudentLiveTypesByDeptId(departmentId).then((list) => {
        this.liveTypeOptions = list || [];
      });
    },
    loadGradesByCampus(campusId, target) {
      if (!campusId) return;
      getSubGrades({ pid: campusId }).then((res) => {
        const list = (res.data && res.data.response) || [];
        if (target === 'edit') this.editGradeOptions = list;
        else this.addGradeOptions = list;
      });
    },
    onEditCampusChange(campusId) {
      this.switchCampus('edit', campusId);
    },
    onAddCampusChange(campusId) {
      this.switchCampus('add', campusId);
    },
    switchCampus(target, campusId) {
      const drafts = target === 'edit' ? this.editGradeDrafts : this.addGradeDrafts;
      const form = target === 'edit' ? this.editForm : this.addForm;
      form.GradeIds = drafts[campusId] ? drafts[campusId].slice() : [];
      this.loadGradesByCampus(campusId, target);
    },
    onEditGradeChange(gradeIds) {
      this.rememberGrades('edit', gradeIds);
    },
    onAddGradeChange(gradeIds) {
      this.rememberGrades('add', gradeIds);
    },
    rememberGrades(target, gradeIds) {
      const campusId = target === 'edit' ? this.editCampusId : this.addCampusId;
      if (!campusId) return;
      const drafts = target === 'edit' ? this.editGradeDrafts : this.addGradeDrafts;
      const otherSelected = Object.keys(drafts).some((key) => String(key) !== String(campusId) && drafts[key] && drafts[key].length);
      if (gradeIds && gradeIds.length && otherSelected) {
        this.$confirm('将替换原校区的年级选择', '提示', { type: 'warning' }).then(() => {
          const next = {};
          next[campusId] = gradeIds.slice();
          if (target === 'edit') this.editGradeDrafts = next;
          else this.addGradeDrafts = next;
        }).catch(() => {
          const form = target === 'edit' ? this.editForm : this.addForm;
          form.GradeIds = [];
        });
        return;
      }
      this.$set(drafts, campusId, (gradeIds || []).slice());
    },
    openStudentPicker(target) {
      this.studentPickerTarget = target;
      this.studentPickerVisible = true;
    },
    clearStudents(target) {
      const form = target === 'edit' ? this.editForm : this.addForm;
      form.StudentIds = [];
      form.StudentNames = [];
    },
    onStudentsPicked(people) {
      const form = this.studentPickerTarget === 'edit' ? this.editForm : this.addForm;
      const list = people || [];
      form.StudentIds = list.map((item) => item.id);
      form.StudentNames = list.map((item) => item.name);
      this.studentPickerVisible = false;
    },
    ensureScopeFields(form) {
      if (!form.ScopeType) form.ScopeType = form.GradeId ? 'condition' : 'all';
      if (!form.GradeIds) form.GradeIds = form.GradeId ? [form.GradeId] : [];
      if (!form.LiveTypeIds) form.LiveTypeIds = [];
      if (!form.StudentIds) form.StudentIds = [];
      if (!form.StudentNames) form.StudentNames = [];
    },
    preserveSelectedGrades(form, target) {
      if (!form || form.ScopeType !== 'condition') return;
      const drafts = target === 'edit' ? this.editGradeDrafts : this.addGradeDrafts;
      const selectedCampusId = Object.keys(drafts).find(key => drafts[key] && drafts[key].length);
      if (selectedCampusId) {
        form.GradeIds = drafts[selectedCampusId].slice();
      }
    },
    getScopeSaveConfirmMessage(form, target) {
      if (!form || form.ScopeType !== 'condition') return '确认提交吗？';
      const drafts = target === 'edit' ? this.editGradeDrafts : this.addGradeDrafts;
      const browsingCampusId = target === 'edit' ? this.editCampusId : this.addCampusId;
      const selectedCampusId = Object.keys(drafts).find(key => drafts[key] && drafts[key].length);
      if (selectedCampusId && browsingCampusId && String(selectedCampusId) !== String(browsingCampusId)) {
        return '当前校区仅用于筛选年级，且尚未选择年级。保存后仍会保留原校区已选年级，是否继续？';
      }
      return '确认提交吗？';
    },
    normalizeScope(form) {
      if (form.ScopeType !== 'condition') {
        form.GradeIds = [];
        form.LiveTypeIds = [];
        form.GradeId = 0;
      } else if (form.GradeIds && form.GradeIds.length) {
        form.GradeId = form.GradeIds[0];
      } else {
        form.GradeId = 0;
      }
      if (form.ScopeType !== 'student') {
        form.StudentIds = [];
        form.StudentNames = [];
      }
    },

    // 新增方法：根据部门ID获取年级列表
    getGradeListByDepartmentId(departmentId) {
      let gradePara = {
        pid: departmentId
      };
      getSubGrades(gradePara).then((res) => {
        if (res.data && res.data.response) {
          this.gradeList = res.data.response;
        }
      });
    },

    // 根据部门ID加载校区列表（调代课使用，结果存入 campusOptions，最终值写入 GradeId 字段）
    loadCampusOptions(departmentId) {
      if (!departmentId) return;
      let para = { page: 1, intPageSize: 999, departmentId: departmentId };
      getCampusList(para).then((res) => {
        if (res.data && res.data.success && res.data.response) {
          this.campusOptions = res.data.response.data || [];
        } else {
          this.campusOptions = [];
        }
      });
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(val, true);
        });
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        usingTypes: 'stu_leave,agent_leave',
        ...this.filters,
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getLeaveApprovalProcessListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeLeaveApprovalProcess(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;

      if (row.GradeId == 0)
        row.GradeId = '';

      this.editForm = Object.assign({
        ScopeType: 'all',
        GradeIds: [],
        LiveTypeIds: [],
        StudentIds: [],
        StudentNames: []
      }, row);
      this.ensureScopeFields(this.editForm);
      this.editCampusId = Number(this.editForm.CampusId) > 0 ? this.editForm.CampusId : '';
      this.editGradeDrafts = {};
      if (this.editCampusId && this.editForm.GradeIds.length) {
        this.$set(this.editGradeDrafts, this.editCampusId, this.editForm.GradeIds.slice());
        this.loadGradesByCampus(this.editCampusId, 'edit');
      }

      let para01 = {
        departmentId: row.DepartmentId,
      };
      getLeaveTypeList(para01).then((res) => {
        this.leaveTypeList = res.data.response;
      });

      // 获取年级列表
      this.getGradeListByDepartmentId(row.DepartmentId);

      // 获取校区列表（调代课时使用，CampusId 写入 GradeId 字段）
      this.loadCampusOptions(row.DepartmentId);
      this.loadLiveTypes(row.DepartmentId);

      this.leaveTypeId = this.editForm.LeaveTypeId;

    },
    //显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.leaveTypeId = "";
      this.addForm = {
        Name: "",
        UsingType: "stu_leave",
        LeaveTypeId: 0,
        ScopeType: 'all',
        GradeIds: [],
        LiveTypeIds: [],
        StudentIds: [],
        StudentNames: [],
        GradeId: '',
        Sort: 0,
        DepartmentId: this.DepartmentId
      };
      this.addCampusId = '';
      this.addGradeDrafts = {};
      this.addGradeOptions = [];

      let para01 = {
        departmentId: this.DepartmentId,
      };
      getLeaveTypeList(para01).then((res) => {
        this.leaveTypeList = res.data.response;
        if (res.data.response && res.data.response.length > 0) {
          this.leaveTypeId = res.data.response[0].Id;
        }
      });

      // 获取年级列表
      this.getGradeListByDepartmentId(this.DepartmentId);

      // 获取校区列表（调代课时使用，CampusId 写入 GradeId 字段）
      this.loadCampusOptions(this.DepartmentId);
      this.loadLiveTypes(this.DepartmentId);
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const confirmMessage = this.getScopeSaveConfirmMessage(this.editForm, 'edit');
          this.$confirm(confirmMessage, "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            this.preserveSelectedGrades(this.editForm, 'edit');
            let para = Object.assign({}, this.editForm);
            this.normalizeScope(para);

            para.LeaveTypeId = this.leaveTypeId;

            editLeaveApprovalProcess(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const confirmMessage = this.getScopeSaveConfirmMessage(this.addForm, 'add');
          this.$confirm(confirmMessage, "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            this.preserveSelectedGrades(this.addForm, 'add');
            let para = Object.assign({}, this.addForm);
            this.normalizeScope(para);

            para.LeaveTypeId = this.leaveTypeId;

            addLeaveApprovalProcess(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },

    //查询审批人员
    handleQueryProcessOfficer() {
      let para = {
        processId: this.processId,
      };
      getProcessOfficer(para).then((res) => {
        if (res.data && res.data.response) {
          // 转换属性名
          const convertedData = convertKeysToLower(res.data.response);

          // 判断当前流程类型
          const process = this.users.find(u => u.Id === this.processId);
          const isAgentLeave = process && process.UsingType === 'agent_leave';

          let mergedNodes = [];
          if (isAgentLeave) {
            // 只对教师代请假做合并
            let firstRoles = [];
            let firstNodeBase = null;
            for (let i = 0; i < convertedData.length; i++) {
              const node = convertedData[i];
              // index==1 且角色为班主任/家长的节点合并
              if (
                node.index === 1 &&
                (node.role === 'classTeacher' || node.role === 'parent')
              ) {
                if (!firstNodeBase) {
                  firstNodeBase = { ...node };
                  firstRoles.push(node.role);
                } else {
                  firstRoles.push(node.role);
                }
                // 如果下一个不是index=1或不是班主任/家长，或者到结尾了，合并
                if (
                  i === convertedData.length - 1 ||
                  convertedData[i + 1].index !== 1 ||
                  (convertedData[i + 1].role !== 'classTeacher' && convertedData[i + 1].role !== 'parent')
                ) {
                  mergedNodes.push({
                    ...firstNodeBase,
                    role: firstRoles,
                    nodeName: firstRoles.map(r => (r === 'classTeacher' ? '班主任' : '家长')).join('/') + '审批'
                  });
                  firstNodeBase = null;
                  firstRoles = [];
                }
              } else {
                mergedNodes.push({ ...node });
              }
            }
          } else {
            // 其他类型不做合并
            mergedNodes = convertedData;
          }

          // 处理specificPerson类型
          this.approvalNodes = mergedNodes.map((node, index) => {
            if (node.role === 'specificPerson') {
              if (node.specificPerson && typeof node.specificPerson === 'string') {
                if (node.specificPerson.includes('|')) {
                  node.specificUsers = node.specificPerson.split('|');
                } else {
                  node.specificUsers = [node.specificPerson];
                }
              } else {
                node.specificUsers = [];
              }
              delete node.specificPerson;
            }
            return {
              ...node,
              index: index + 1,
              specificUsers: node.specificUsers || [],
              days: node.days || 0,
              hours: node.days ? Math.round(node.days * 24 * 100) / 100 : 0 // 自动换算小时
            };
          });
        }
      });
    },

    //显示添加审批节点页面
    showAddApprovalNode(row) {
      this.approvalNodes = [];
      this.addApprovalNodeVisible = true;
      this.processId = row.Id;
      this.nodeScopeDepartmentId = row.DepartmentId;
      this.nodeUserNameMap = {};

      let par = { departmentId: row.DepartmentId };
      if (this.isAdjustCourseType(row.UsingType)) {
        // 调代课：按部门 + 校区筛选课表管理员
        if (row.GradeId) {
          par.campusId = row.GradeId;
        }
        getScheduleAdminsForApproval(par).then((res) => {
          console.log(res.data.response);
          this.userList = res.data.response;
        });
      } else {
        getTeacherMasterList(par).then((res) => {
          this.userList = res.data.response;
        });
      }

      this.handleQueryProcessOfficer();
    },

    // 添加新节点：默认取当前可选的第一个未使用角色，角色都已用完时为指定人员。最后修改：2026-10-03
    addNode() {
      const index = this.approvalNodes.length;
      const availableRole = this.getRoleOptions(index).find(item => item.value !== 'specificPerson');
      const newRole = availableRole ? availableRole.value : 'specificPerson';

      const newNode = {
        index: index + 1,
        nodeName: '',
        role: newRole,
        specificUsers: [],
        days: 0, // 新增天数属性
      };
      // 生成默认节点名称
      this.generateNodeName(newNode);
      this.approvalNodes.push(newNode);
    },
    // 删除节点
    removeNode(index) {
      this.$confirm('确定要删除该审批节点吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.approvalNodes.splice(index, 1);
        // 重新更新序号
        this.approvalNodes.forEach((node, i) => {
          node.index = i + 1;
        });
      }).catch(() => {
        // 用户取消删除
      });
    },
    // 角色改变时，如果不是指定人员则清空指定人员选择
    roleChange(index) {
      if (this.approvalNodes[index].role !== 'specificPerson') {
        this.approvalNodes[index].specificUsers = [];
      }
      // 角色改变时重新生成节点名称
      this.generateNodeName(this.approvalNodes[index]);
    },
    // 新增方法，处理指定人员选择变化
    specificUsersChange(index) {
      this.generateNodeName(this.approvalNodes[index]);
    },
    // 按 TeacherMaster.Id 取指定人员姓名：优先通讯录选中结果，其次教师列表。创建于 2026-10-03
    getNodeUserName(id) {
      const key = String(id);
      if (this.nodeUserNameMap[key]) return this.nodeUserNameMap[key];
      const user = (this.userList || []).find(u => String(u.Id) === key);
      return user ? user.TeacherName : '';
    },
    // 打开审批节点指定人员通讯录。创建于 2026-10-03
    openNodePicker(index) {
      this.nodePickerIndex = index;
      this.nodePickerVisible = true;
    },
    // 通讯录选完回填审批节点指定人员，并同步节点名称。创建于 2026-10-03
    onNodePicked(people) {
      const node = this.approvalNodes[this.nodePickerIndex];
      if (node) {
        const list = people || [];
        const nameMap = { ...this.nodeUserNameMap };
        list.forEach(p => {
          nameMap[String(p.id)] = p.name || '';
        });
        this.nodeUserNameMap = nameMap;
        node.specificUsers = list.map(p => String(p.id));
        this.generateNodeName(node);
      }
      this.nodePickerVisible = false;
    },
    // 指定人员姓名拼接，用于悬停提示。创建于 2026-10-03
    getNodeUserNames(node) {
      return (node.specificUsers || []).map(id => this.getNodeUserName(id) || id).join('、');
    },
    // 生成节点名称的方法
    generateNodeName(node) {
      const roleMap = {
        headmaster: '校长',
        prefect: '年级组长',
        manager: '部门主管',
        classTeacher: '班主任',
        parent: '家长'
      };
      if (Array.isArray(node.role)) {
        node.nodeName = node.role.map(r => roleMap[r] || r).join('/') + '审批';
      } else if (node.role === 'specificPerson') {
        const names = node.specificUsers.map(id => this.getNodeUserName(id)).filter(name => name);
        node.nodeName = names.join('、') + '审批';
      } else {
        node.nodeName = (roleMap[node.role] || node.role) + '审批';
      }
    },


    // 输入天数时自动同步小时
    handleDaysInput(index) {
      let days = this.approvalNodes[index].days;
      if (days !== '' && days !== null && days !== undefined) {
        days = Number(days);
        if (!isNaN(days)) {
          days = Math.floor(days * 100) / 100;
          this.approvalNodes[index].days = days;
          // 自动同步小时
          this.approvalNodes[index].hours = Math.round(days * 24 * 100) / 100;
        }
      }
      const form = this.$refs[`approvalForm${index}`];
      if (form) {
        form.clearValidate('days');
      }
    },

    // 输入小时时自动转换为天数
    handleHoursInput(index) {
      let hours = this.approvalNodes[index].hours;
      if (hours !== '' && hours !== null && hours !== undefined) {
        hours = Number(hours);
        if (!isNaN(hours)) {
          // 自动转换为天，保留两位小数
          const days = Math.floor((hours / 24) * 100) / 100;
          this.approvalNodes[index].days = days;
        }
      }
      const form = this.$refs[`approvalForm${index}`];
      if (form) {
        form.clearValidate('days');
      }
    },

    async submitForm() {
      // 节点名称页面不展示，保存前按角色 / 指定人员统一生成
      this.approvalNodes.forEach(node => this.generateNodeName(node));
      // 如果存在节点，则要求“指定人员”节点必须选择人员；没有任何节点时允许直接提交（视为无需审批）
      if (this.approvalNodes && this.approvalNodes.length > 0) {
        const invalidSpecificNode = this.approvalNodes.find(n =>
          n.role === 'specificPerson' &&
          (!n.specificUsers || n.specificUsers.length === 0)
        );
        if (invalidSpecificNode) {
          this.$message.error('存在指定人员节点未选择具体审批人，请先选择人员');
          return;
        }
      }

      let isValid = true;
      for (let i = 0; i < this.approvalNodes.length; i++) {
        const form = this.$refs[`approvalForm${i}`];
        if (form) {
          await new Promise((resolve) => {
            form.validate((valid) => {
              if (!valid) {
                isValid = false;
              }
              resolve();
            });
          });
        }
      }

      if (isValid) {
        let nodesToSave = [];

        if (this.isAgentLeave) {
          // 教师代请假：第一节点多选要拆分，index都为1，后续节点index递增
          let nextIndex = 2;
          for (let i = 0; i < this.approvalNodes.length; i++) {
            const node = this.approvalNodes[i];
            if (i === 0 && Array.isArray(node.role)) {
              node.role.forEach((roleVal) => {
                nodesToSave.push({
                  ...node,
                  role: roleVal,
                  nodeName: (roleVal === 'classTeacher' ? '班主任' : '家长') + '审批',
                  index: 1,
                });
              });
            } else {
              nodesToSave.push({
                ...node,
                index: nextIndex++,
              });
            }
          }
        } else {
          // 其他类型（如学生请假）：直接保存，每个节点一个，index递增
          nodesToSave = this.approvalNodes.map((node, idx) => ({
            ...node,
            index: idx + 1,
          }));
        }

        var para = {
          processId: this.processId,
          processOfficerDetails: nodesToSave
        };

        this.$confirm("确认提交吗？", "提示", {}).then(() => {
          addProcessOfficer(para).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.msg);
              this.handleQueryProcessOfficer();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        });
      } else {
        this.$message.error('表单存在验证错误，请检查');
      }
    },

    // 显示抄送人员设置弹窗
    showCopyToUsers(row) {
      this.currentProcessId = row.Id;
      this.currentUsingType = row.UsingType;
      this.ccScopeDepartmentId = row.DepartmentId;
      this.copyToForm = this.createEmptyCopyToForm();
      this.copyToUsersVisible = true;

      // 调代课：按部门 + 校区筛选课表管理员；其它流程走内部通讯录，无需预拉全员
      if (this.isAdjustCourseType(row.UsingType)) {
        let par = { departmentId: row.DepartmentId };
        if (row.GradeId) {
          par.campusId = row.GradeId;
        }
        getScheduleAdminsForApproval(par).then((res) => {
          this.userList = res.data.response;
        });
      }

      // 获取已设置的抄送人员
      this.getCopyToUsers();
    },

    // 抄送弹窗默认值：班主任默认不抄送，家长默认通知。创建于 2026-10-03
    createEmptyCopyToForm() {
      return { copyToUsers: [], copyToNames: [], ccClassTeacher: false, notifyParent: true };
    },

    // 获取抄送人员配置
    getCopyToUsers() {
      let para = {
        processId: this.currentProcessId
      };
      getProcessCc(para).then((res) => {
        const cc = res.data && res.data.response;
        if (cc) {
          this.copyToForm = {
            copyToUsers: (cc.CcPersonIds || '').split('|').filter(id => id),
            copyToNames: (cc.CcPersonNames || '').split('|'),
            ccClassTeacher: !!cc.CcClassTeacher,
            notifyParent: cc.NotifyParent !== false
          };
        } else {
          this.copyToForm = this.createEmptyCopyToForm();
        }
      }).catch(() => {
        this.copyToForm = this.createEmptyCopyToForm();
      });
    },

    // 通讯录选完抄送人员回填。创建于 2026-10-03
    onCcPicked(people) {
      const list = people || [];
      this.copyToForm.copyToUsers = list.map(p => String(p.id));
      this.copyToForm.copyToNames = list.map(p => p.name || '');
      this.ccPickerVisible = false;
    },
    removeCcUser(index) {
      this.copyToForm.copyToUsers.splice(index, 1);
      this.copyToForm.copyToNames.splice(index, 1);
    },
    clearCcUsers() {
      this.copyToForm.copyToUsers = [];
      this.copyToForm.copyToNames = [];
    },

    // 保存抄送人员配置
    saveCopyToUsers() {
      // 调代课抄送人员至少选择一人；请假类可只配置开关
      if (!this.isLeaveCcType && (!this.copyToForm.copyToUsers || this.copyToForm.copyToUsers.length === 0)) {
        this.$message.error('请至少选择一名抄送人员');
        return;
      }
      this.copyToLoading = true;

      // 构建参数，将ID数组转换为竖线分隔字符串，并添加对应的用户名
      const ccNames = this.isAdjustCourseType(this.currentUsingType)
        ? this.copyToForm.copyToUsers.map(userId => {
          const user = this.userList.find(u => String(u.Id) === String(userId));
          return user ? user.TeacherName : '';
        })
        : this.copyToForm.copyToNames;
      let para = {
        processId: this.currentProcessId,
        ccPersonIds: this.copyToForm.copyToUsers.join('|'),
        ccPersonNames: ccNames.join('|'),
        ccClassTeacher: this.isLeaveCcType ? !!this.copyToForm.ccClassTeacher : false,
        notifyParent: this.isLeaveCcType ? this.copyToForm.notifyParent !== false : true
      };

      saveProcessCc(para).then((res) => {
        this.copyToLoading = false;

        if (res.data && res.data.success) {
          this.$message({
            message: res.data.msg || "保存成功",
            type: "success"
          });
          this.copyToUsersVisible = false;
        } else {
          this.$message({
            message: res.data.msg || "保存失败",
            type: "error"
          });
        }
      }).catch(() => {
        this.copyToLoading = false;
        this.$message({
          message: "保存失败，请重试",
          type: "error"
        });
      });
    }

  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.dialog-footer {
  text-align: center;
}

.dialog-title {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 12px;
}

.title-tip {
  color: #999;
  font-size: 13px;
  font-weight: normal;
}

.title-tip .action-link {
  color: var(--btn-primary, #2563eb);
  cursor: pointer;
  font-weight: 500;
}

/* 表单已选学生面板。创建于 2026-10-03 */
.picked-panel {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background-color: #f8fafc;
  padding: 8px 12px;
  line-height: normal;
}

.picked-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.picked-count {
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
}

.picked-empty {
  font-size: 13px;
  color: #94a3b8;
}

.cc-switch-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}

.picked-actions {
  flex-shrink: 0;
}

.picked-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #e2e8f0;
}

.picked-tags .el-tag {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.picked-more {
  cursor: pointer;
}

.picked-tags-scroll {
  max-height: 120px;
  overflow-y: auto;
}

/* 审批节点网格：角色 / 审批人 / 节点名称 / 审批时长 / 操作。创建于 2026-10-03 */
.node-grid {
  display: grid;
  grid-template-columns: 160px 190px 250px 64px;
  column-gap: 16px;
  align-items: center;
}

.node-grid.no-duration {
  grid-template-columns: 160px 220px 64px;
}

.node-grid-head {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.node-head-help {
  margin-left: 2px;
  color: #94a3b8;
  cursor: help;
}

.node-head-op,
.node-op {
  text-align: center;
}

.node-grid /deep/ .el-form-item {
  margin: 0;
}

.node-grid /deep/ .el-select,
.node-grid /deep/ .el-input {
  width: 100%;
}

.node-grid /deep/ .el-form-item__error {
  padding-top: 2px;
}

.node-table /deep/ .el-table__row td {
  padding: 14px 0;
}

/* split-layout.css 会把含按钮的单元格设为 inline-flex 居中，网格需撑满整格 */
.node-table /deep/ td.el-table__cell > .cell,
.node-table /deep/ th.el-table__cell > .cell {
  display: block !important;
  width: 100%;
  text-align: left;
}

.node-table /deep/ td.el-table__cell:first-child > .cell,
.node-table /deep/ th.el-table__cell:first-child > .cell {
  text-align: center;
}

.node-grid {
  width: 100%;
  text-align: left;
}

.node-grid /deep/ .el-form-item__content {
  display: block;
  width: 100%;
  margin-left: 0 !important;
}

.node-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 12px;
  font-weight: 600;
}

.node-auto {
  box-sizing: border-box;
  height: 40px;
  line-height: 38px;
  padding: 0 12px;
  border: 1px dashed #e2e8f0;
  border-radius: 4px;
  background: #f8fafc;
  color: #94a3b8;
  font-size: 13px;
}

.node-duration {
  display: flex;
  align-items: center;
}

.node-duration /deep/ .el-input-number {
  width: 92px;
}

.node-duration /deep/ .el-input-number .el-input__inner {
  padding-left: 8px;
  padding-right: 40px;
  text-align: left;
}

.node-unit {
  margin: 0 10px 0 6px;
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
}

.node-del-btn {
  color: #ef4444;
}

.node-del-btn:hover,
.node-del-btn:focus {
  color: #dc2626;
}

.node-foot-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #94a3b8;
}

.node-picked {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #409eff;
  cursor: pointer;
  vertical-align: middle;
  transition: border-color 0.2s;
}

.node-picked:hover {
  border-color: #409eff;
}

.node-picked.is-empty {
  color: #c0c4cc;
}

.node-picked-text {
  flex: 1;
  margin-left: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.node-picked-arrow {
  color: #c0c4cc;
}

/* 列表适用范围快速查看按钮。创建于 2026-10-03 */
.scope-link-btn {
  padding: 4px 10px;
  font-size: 13px;
  color: #2563eb;
  background-color: #eff6ff;
  border-radius: 4px;
  line-height: 18px;
  border: 1px solid #bfdbfe;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.scope-link-btn:hover,
.scope-link-btn:focus {
  color: #1d4ed8;
  background-color: #dbeafe;
  border-color: #93c5fd;
}

.scope-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  padding: 2px 8px;
}
</style>

<style>
/* 适用范围查看弹窗（append-to-body，需非 scoped）。创建于 2026-10-03 */
.scope-view-dialog .el-dialog__body {
  padding: 16px 20px 10px;
}

.scope-view-dialog .scope-view-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 16px;
  margin-bottom: 14px;
}

.scope-view-dialog .scope-view-head-item {
  font-size: 13px;
  color: #334155;
}

.scope-view-dialog .scope-view-head-item .label {
  color: #64748b;
}

.scope-view-dialog .scope-view-head-item .val {
  font-weight: 500;
  color: #0f172a;
}

.scope-view-dialog .scope-view-head-item .count-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: 12px;
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}

.scope-view-dialog .scope-view-toolbar {
  margin-bottom: 12px;
}

.scope-view-dialog .scope-view-search-input {
  max-width: 280px;
}

.scope-view-dialog .scope-view-empty {
  padding: 30px 0;
  color: #94a3b8;
  font-size: 13px;
}
</style>
